import React from 'react'
import { getLocationUsers } from '@/lib/actions/global/get-location-users'
import { cn } from '@/lib/utils'

import { ScrollArea, UserCardList } from '@/components/ui'

interface AccountListProps extends React.ComponentPropsWithoutRef<'div'> {
  branch: string
}

export const AccountList = async ({ className, branch }: AccountListProps) => {
  const users = await getLocationUsers(branch)

  return (
    <ScrollArea
      className={cn(
        'relative w-full overflow-auto pr-4',
        'before:absolute before:left-0 before:right-0 before:top-0 before:z-10 before:h-8 before:bg-gradient-to-b before:from-gray-50 before:to-transparent before:content-[""]',
        'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-8 after:bg-gradient-to-t after:from-gray-50 after:to-transparent after:content-[""]',
        className,
      )}
      thumbClassName="bg-transparent"
    >
      <UserCardList
        className="flex flex-col gap-1 pb-8 pt-7"
        list={users}
        branch={branch}
      />
    </ScrollArea>
  )
}
